import React from 'react';
import SearchContext from './components/SearchContext';
import AnimatedBackground from './components/AnimatedBackground';
import Header from './components/Header';
import NavBar from './components/NavBar';
import SearchBar from './components/SearchBar';
import Player from './components/player/Player';
import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import './theme.css';
import './globals.css';
import './style.css';
import { getData, saveToDB, darkModeKey } from './components/util/dbUtils';

export default function App() {
  const initTheme = () => {
    let darkMode = getData(darkModeKey);
    if (darkMode.length !== 0) {
      let darkMode_ = getData(darkModeKey);
      //console.log(darkMode_);
      let modeStatus = darkMode_['status'];
      return Boolean(modeStatus);
      //setDarkTheme(modeStatus);
    } else {
      saveToDB({ status: false }, darkModeKey);
      return false; //Means dark theme off
    }
  };
  const [searchQuery, updateِSearchQuery] = React.useState('');
  const [darkTheme, setDarkTheme] = React.useState(initTheme);
  //React.useEffect(() => {}, []);
  React.useEffect(() => {
    //Problem: need to close the warning after connections is restored
    
    window.addEventListener('online', () =>
      toast.info('Your internet connection was restored 😎.', {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      })
    );

    window.addEventListener('offline', () =>
      toast.warn('You are currently offline 😐!', {
        position: 'top-center',
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      })
    );
  }, []);

  const handleSearch = event => {
    updateِSearchQuery(event.target.value);
  };
  const handleClearSearch = event => {
    updateِSearchQuery('');
  };
  return (
    <div className={`App ${darkTheme ? 'dark' : 'light'}`}>
      {/*<AnimatedBackground /> */}
      <ToastContainer
        position="top-center"
        autoClose={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
      />
      <Header>
        <NavBar>
          <a
            className="navbar-item"
            onClick={() => {
              let newStatus = !darkTheme;
              setDarkTheme(newStatus);
              //save to db
              saveToDB({ status: newStatus }, darkModeKey);
            }}
          >
            <i
              className={
                darkTheme
                  ? 'fa fa-moon-o fa-fw fa-2x button'
                  : 'fa fa-sun-o fa-fw fa-2x button'
              }
            >
              {' '}
            </i>
          </a>

          <SearchBar
            onSearch={handleSearch}
            onClearSearch={handleClearSearch}
            searchQuery={searchQuery}
            placeholderText="بحث عن سورة ..."
          />
        </NavBar>
      </Header>
      <SearchContext.Provider value={{ searchQuery, updateِSearchQuery }}>
        <Player />
      </SearchContext.Provider>
    </div>
  );
}
